import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';

class Component extends BaseComponent {
    render() {
        return (
            <section id='notes' />
        );
    }
}

export default connect()(Component);